/**
=========================================================
* Series Header Component
=========================================================
*/

import { Card, CardContent, Box, Typography, Chip } from "@mui/material";
import parse from "html-react-parser";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SportsCricketIcon from "@mui/icons-material/SportsCricket";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

function SeriesHeader({ seriesData }) {
  if (!seriesData) return null;

  const formatDate = (dateString) => {
    if (!dateString) return "TBD";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch (error) {
      return dateString;
    }
  };

  return (
    <Card elevation={3} sx={{ mb: 3 }}>
      <CardContent sx={{ p: 4 }}>
        <Box display="flex" alignItems="center" mb={3}>
          {seriesData.league_logo && (
            <Box
              component="img"
              src={seriesData.league_logo}
              alt="League Logo"
              sx={{
                height: 60,
                width: "auto",
                mr: 2,
                borderRadius: 1,
              }}
            />
          )}
          <Box>
            <SoftTypography variant="h3" color="error" fontWeight="bold">
              {seriesData.series_name} - REGISTRATION
            </SoftTypography>
            
          </Box>
        </Box>

        {(seriesData.header_description || seriesData.league_logo_header_img) && (
          <Box sx={{ mb: 3 }}>
            <Box display={{ xs: 'block', md: 'grid' }} sx={{ gridTemplateColumns: '1fr 380px', gap: 3 }}>
              {/* Left: rich description */}
              {seriesData.header_description && (
                <div
                  style={{ lineHeight: 1.8, fontSize: "1.05rem", color: "#344767" }}
                >
                  {parse(String(seriesData.header_description))}
                </div>
              )}

              {/* Right: poster image */}
              {seriesData.league_logo_header_img && (
                <Box
                  component="img"
                  src={seriesData.league_logo_header_img}
                  alt="League Poster"
                  sx={{
                    width: '100%',
                    maxHeight: 500,
                    objectFit: 'cover',
                    borderRadius: 2,
                    boxShadow: 1,
                  }}
                />
              )}
            </Box>
          </Box>
        )}

        <Box display="flex" flexWrap="wrap" gap={1}>
          <Chip
            icon={<SportsCricketIcon />}
            label="Cricket Tournament"
            color="primary"
            variant="outlined"
          />
          <Chip
            label="Public Registration"
            color="success"
            variant="outlined"
          />
          
        </Box>
      </CardContent>
    </Card>
  );
}

export default SeriesHeader;
